import React from "react"
import { useNavigate } from "react-router-dom"
import NotificationDropdown from "../LayoutCommonComponents/NotifcationDropdown"
import { ICONS } from "../../constants/icons"

/**
 * Admin header notifications — reuses member NotificationDropdown UI.
 */
const AdminNotificationDropdown = () => {
  const navigate = useNavigate()

  return (
    <NotificationDropdown
      toggleVariant="admin"
      iconSrc={ICONS.adminNotification}
      onViewAll={() => navigate("/admin/notifications")}
    />
  )
}

export default AdminNotificationDropdown
